export default __webpack_public_path__ + "04fc63e84013e5de04af055aab035edb.png";